(function ($, App, Utils, Components) {
  'use strict';

  const logger = new Logger('LocalizationFieldsSelect');

  Components.create('LocalizationFieldsSelect', {

    Selectors: {
      main: '[data-localization-select=true]'
    },

    SortObjectByKeys: function (obj) {
      return Object.keys(obj).sort().reduce((result, key) => (result[key] = obj[key], result), {});
    },
    Select2Cascade: function(parent, child, url, select2Options, disabled=false) {

      let afterActions = [];
      let options = select2Options || {};

      // Register functions to be called after cascading data loading done
      this.then = function(callback) {
        afterActions.push(callback);
        return this;
      };

      if (disabled) $(child).prop("disabled", true);

      if (Utils.Responsive.getCurrentResolution().label === 'xs' &&
          $(parent).hasClass("select2-hidden-accessible")
      ) {
        $(parent).on('select2:open', function (e) {
          let searchField = document.querySelector('.select2-search__field');
          $(searchField).hide();
        })
      }

      $(parent).select2(select2Options).on("change", function (e) {

        if ($(this).val()) {
          let actionUrl = url + $(this).val();

          $.getJSON(actionUrl, function(items) {

            Components.LocalizationFieldsSelect.generateNewOptions(child, items, options, false);

            afterActions.forEach(function (callback) {
              callback($(parent), $(child), items);
            });

          });
        } else {
          Components.LocalizationFieldsSelect.generateNewOptions(child, null, options);
        }

      });
    },
    generateNewOptions: function (field, items, options, disabled=true) {
      let defaultLabel = $(field).data('defaultLabel'),
          newOptions = `<option value="">${defaultLabel}</option>`;

      if (items) {
        let numItems = Object.keys(items).length;
        for(let id in Components.LocalizationFieldsSelect.SortObjectByKeys(items)) {
          if (numItems === 1) {
            newOptions = `<option value="${id}">${items[id]}</option>`
          } else {
            newOptions += `<option value="${id}">${items[id]}</option>`
          }
        }
      }

      $(field).select2('destroy').html(newOptions).prop("disabled", disabled).select2(options);
      $(field).trigger('change');
    },

    init: function () {
      const select2Options = { width: 'resolve',theme: 'custom'};
      const baseUrl =  $('#actionUrl').data('url');

      $(Components.LocalizationFieldsSelect.Selectors.main).each(function () {
        $(this).select2(select2Options);
        let bind = $(this).data('localizationBind'),
            disabled= $(this).data('disabled-bind'),
            endPoint = $(this).data('endPoint'),
            endPointUrl = `${baseUrl}${endPoint}/`;

        if (endPoint) Components.LocalizationFieldsSelect.Select2Cascade(this, `#${bind}`, endPointUrl, select2Options, disabled);
      });

    }
  });
})(jQuery, window.App, window.App.Utils, window.App.Components);